import { createContext } from "react";

export const TokenReclasificacionContext = createContext({
  status: "idle",
  tokenResiclasificacion: null,
  TokenReclasificacionIn: () => Promise.resolve(),
  TokenReclasificacionOut: () => Promise.resolve(),
});
